/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2017-08-09, 10:34:04
 * Author: Sebastian Drzewicki <sebastian.drzewicki@telestrada.pl>
 * =============================================================================
 * Last Modified: 2018-02-26, 14:03:58
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2017 Telestrada
 * =============================================================================
 */
export const TOGGLE_OFFLINE_STATUS = 'TOGGLE_OFFLINE_STATUS';
export const TOGGLE_PENDING_STORE_ACTIONS = 'TOGGLE_PENDING_STORE_ACTIONS';
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU';
export const FILL_BANNERS_LIST = 'FILL_BANNERS_LIST';
export const FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY = 'FILL_INFORMATIONS_ABOUT_COMPONENTS_VISIBILITY';
export const FILL_PANEL_FOOTER_ICONS = 'FILL_PANEL_FOOTER_ICONS';
export const FILL_RODO_TERMS = 'FILL_RODO_TERMS';
export const FILL_OCCASION_ZONE_TILES_CONTENTS = 'FILL_OCCASION_ZONE_TILES_CONTENTS';
export const FILL_OCCASION_ZONE_FORM_SETTINGS = 'FILL_OCCASION_ZONE_FORM_SETTINGS';



// WEBPACK FOOTER //
// ./src/store/modules/App/mutation-types.js